/* CELEBRATEVITAMINS CUSTOM — keeps "price per day" in sync when a variant changes.
 * Every snippets/unit-price.liquid block carries data-cv-ppd-map = { variantId: "€1,17/dag", ... }.
 * - Product pages: listens to Stiletto's 'product:variant-change' event.
 * - Quick-add cards: assets/quick-add-card.js calls window.cvPpdUpdate(root, variantId).
 */
(function () {
  if (window.__cvPpdLoaded) return;
  window.__cvPpdLoaded = true;
  function apply(el, id) {
    var map;
    try { map = JSON.parse(el.getAttribute('data-cv-ppd-map') || '{}'); } catch (e) { return; }
    if (!Object.prototype.hasOwnProperty.call(map, String(id))) return;
    var text = map[String(id)] || '';
    var out = el.querySelector('[data-cv-ppd]');
    if (out) out.textContent = text;
    el.classList.toggle('unit-price--available', !!text);
    var dd = el.querySelector('.unit-price__price');
    if (dd) dd.classList.toggle('unit-price--available', !!text);
  }
  window.cvPpdUpdate = function (scope, id) {
    if (!id) return;
    (scope || document).querySelectorAll('[data-cv-ppd-map]').forEach(function (el) { apply(el, id); });
  };
  document.addEventListener('product:variant-change', function (evt) {
    var v = evt && evt.detail && evt.detail.variant;
    if (v && v.id) window.cvPpdUpdate(document, v.id);
  });
})();